/**
 * Created by or_p on 7/4/2016.
 */
import PropTypes from 'prop-types';

import React, { Component } from 'react';

export default class CustomBorderRadiusInput extends Component {
  render() {
    const {onChange} = this.props;
    const value = parseInt(this.props.value, 10);
    return (
      <div style={{position: 'relative', display: 'flex', flexWrap: 'wrap', justifyContent: 'space-around'}}>
        <input
          type="number"
          value={value}
          onChange={(event) => {onChange(`${event.target.value}px`);}}
        />
      </div>
    );
  }
}

CustomBorderRadiusInput.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};